module.exports = __webpack_public_path__ + "media/images/about-trainer_profile-trainer@2x-119279d1e1b408086520666aaefe1b74.jpg";